module.exports = __webpack_public_path__ + "static/4-dc2ed6b4afa299ec5f4651cbde2536e3.jpg";